const docx = require("docx");
const {  Paragraph} = docx;

export const __PageBreak = () => new Paragraph({
    text: "",
    pageBreakBefore: true,
})
